import ArticlePage from './ArticlePage';
import { comparisonArticles } from '@/mocks/articles';

export default function CSSBuyComparisonPage() {
  return <ArticlePage data={comparisonArticles.cssbuy} />;
}